var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"partners-section"},[_c('div',{staticClass:"partners-slider"},[_c('div',{staticClass:"slider-track"},_vm._l((_vm.duplicatedLogos),function(logo,index){return _c('img',{key:`logo- ${index}`,staticClass:"partner-logo",attrs:{"src":logo,"alt":'Parceiro ' + (index + 1)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }